var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGreenCircleCheckmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8083",
    "data-name": "Group 8083",
    transform: "translate(-557 -299)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_569",
    "data-name": "Ellipse 569",
    cx: 80,
    cy: 80,
    r: 80,
    transform: "translate(557 299)",
    fill: "#71be08"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_iconCheckmark",
    "data-name": "$iconCheckmark",
    transform: "translate(597 351.235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "checkmark",
    d: "M78.123,12.019,36.015,53.625a10.444,10.444,0,0,1-12.022,0L2.107,32.017A7.018,7.018,0,0,1,1.182,23.1a3.772,3.772,0,0,1,.925-1.053,7.13,7.13,0,0,1,10.234,0L29.973,39.632,67.827,2.051a7.253,7.253,0,0,1,10.111,0,7.143,7.143,0,0,1,.863,8.977,6.626,6.626,0,0,1-.678.991Z",
    transform: "translate(0.002 0.001)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGreenCircleCheckmark);
export default __webpack_public_path__ + "static/media/icon-green-circle-checkmark.50367442.svg";
export { ForwardRef as ReactComponent };